import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';

import { FilterWrapperState, IFilterWrapperState } from './filter-wrapper-states.store';
import { mutations } from './filter-wrapper-mutations.store';
import { actions } from './filter-wrapper-actions.store';
import { getters } from './filter-wrapper-getters.store';

export class FilterWrapperModule<RootState> implements Module<IFilterWrapperState, RootState>{
    namespaced: boolean;
    state: IFilterWrapperState;
    getters: GetterTree<IFilterWrapperState, RootState>;
    actions: ActionTree<IFilterWrapperState, RootState>;
    mutations: MutationTree<IFilterWrapperState>;
    
    constructor() {
        this.namespaced = true;
        this.state = new FilterWrapperState();
        this.mutations = mutations;
        this.actions = actions;
        this.getters = getters;
    }
}